import { newAPI } from '../newAxios';

// API call function for fetching user profile
export const fetchUserProfileAPI = async () => {
    try {
        const response = await newAPI.get('/user/profile');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchEmployeeAddressAPI = async () => {
    try {
        const response = await newAPI.get('/employeeAddress/self');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchEmployeeEducationAPI = async () => {
    try {
        const response = await newAPI.get('/employeeEducation/self');
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const fetchEmployeeExperienceAPI = async () => {
    try {
        const response = await newAPI.get('/employeeExperience/self');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchEmployeeDocumentsAPI = async () => {
    try {
        const response = await newAPI.get('/employeeDocument/self');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchEmployeeBankAccountAPI = async () => {
    try {
        const response = await newAPI.get('/employeeAccount/self');
        return response.data;
    } catch (error) {
        throw error;
    }
};
